import React, { ReactElement } from 'react';
import ReactModal from 'react-modal';
import generateLocator from 'utils/generate-locator';
import { Button } from '../Button';
import './Modal.css';

interface ButtonProps {
  text: string,
  onClick: () => void,
  style?: string,
}

interface ModalProps {
  isOpen: boolean,
  id?: string,
  buttons: ButtonProps[]
  heading: string,
  children?: React.ReactNode
}

const Modal = (props: ModalProps): ReactElement => {
  // Derive an id. For example, "Empty cart?" will become "empty_cart_modal"
  const id = props.id || generateLocator(props.heading, 'modal');

  return <ReactModal
    ariaHideApp={process.env.NODE_ENV !== 'test'}
    className='absolute top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 max-w-2xl m-auto w-2/5 border border-gray-400 rounded-md pt-10 p-8 bg-gray-50'
    appElement={document.getElementById('app-root') as HTMLElement}
    isOpen={props.isOpen}
    id={id}
    data-locator="modal"
    aria={{
      labelledby: `${id}-heading`,
      describedby: `${id}-body`,
    }}
    closeTimeoutMS={200}
  >
    <h2 id={`${id}-heading`} className='text-3xl font-bold'>{props.heading}</h2>
    <div id={`${id}-body`} className='mt-4 mb-12'>{props.children}</div>
    <span className='flex mb-2 mt-6 mx-10 justify-end'>
      {props.buttons.map(({ text, onClick, style }) => {
        const buttonId = generateLocator('modal', text, 'button');
        const buttonProps = {
          id: buttonId,
          className: 'w-1/4 mr-4',
          onClick,
        };
        return <Button
          {... style ? { [style]: true } : { primary: true } }
          key={buttonId}
          {...buttonProps}
        >{text}</Button>;
      })}
    </span>
  </ReactModal>;
};

export default Modal;
